import type { Client } from '@urql/core'
import { graphql } from 'app/generated/gql'

import type { WorkspaceInvite as WorkspaceInviteType, WorkspaceInviteListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const WORKSPACE_INVITE_FIELDS = `code createdAt createdDate email expiresAt id invitedBy locationIds orgId roleId staffId updatedDate userId version workspaceId`

const LIST_QUERY = graphql(`
  query WorkspaceInvites($search: String, $pagination: PaginationInput, $sort: SortInput) {
    workspaceInvites(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        code
        createdAt
        createdDate
        email
        expiresAt
        id
        invitedBy
        locationIds
        orgId
        roleId
        staffId
        updatedDate
        userId
        version
        workspaceId
      }
      total
      page
    }
  }
`)

const GET_QUERY = graphql(`
  query WorkspaceInvite($id: ID!) {
    workspaceInvite(id: $id) {
      code
      createdAt
      createdDate
      email
      expiresAt
      id
      invitedBy
      locationIds
      orgId
      roleId
      staffId
      updatedDate
      userId
      version
      workspaceId
    }
  }
`)

const CREATE_MUTATION = graphql(`
  mutation CreateWorkspaceInviteStore($input: CreateWorkspaceInviteInput!) {
    createWorkspaceInvite(input: $input) {
      code
      createdAt
      createdDate
      email
      expiresAt
      id
      invitedBy
      locationIds
      orgId
      roleId
      staffId
      updatedDate
      userId
      version
      workspaceId
    }
  }
`)

const UPDATE_MUTATION = graphql(`
  mutation UpdateWorkspaceInvite($id: ID!, $input: UpdateWorkspaceInviteInput!) {
    updateWorkspaceInvite(id: $id, input: $input) {
      code
      createdAt
      createdDate
      email
      expiresAt
      id
      invitedBy
      locationIds
      orgId
      roleId
      staffId
      updatedDate
      userId
      version
      workspaceId
    }
  }
`)

const DELETE_MUTATION = graphql(`
  mutation DeleteWorkspaceInvite($id: ID!) {
    deleteWorkspaceInvite(id: $id)
  }
`)

export class WorkspaceInviteStore extends EntityStore<
  WorkspaceInviteType,
  WorkspaceInviteListResult,
  typeof CREATE_MUTATION,
  typeof UPDATE_MUTATION
> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: GET_QUERY,
      createMutation: CREATE_MUTATION,
      updateMutation: UPDATE_MUTATION,
      deleteMutation: DELETE_MUTATION,
      typename: `WorkspaceInvite`,
      extractList: (data: any) => data.workspaceInvites,
      extractOne: (data: any) => data.workspaceInvite,
      extractMutated: (data: any) => data.createWorkspaceInvite ?? data.updateWorkspaceInvite,
    })
  }
}
